import { useAuth } from "@/context/AuthContext";
import { bilingual, langDir } from "@/lib/lang";

/** Hook per le etichette dell'app operatore in base alla `preferred_language`.
 *  - qualsiasi ruolo operativo con lingua non italiana → SOLO la sua lingua (RTL per l'urdu)
 *  - italiano → solo italiano
 *  L'admin vede sempre l'app in italiano. */
export function useBilingual() {
  const { user } = useAuth();
  const lang = user?.preferred_language || "it";
  const translatedOnly = lang !== "it";

  return {
    lang,
    isBilingual: lang !== "it",
    translatedOnly,
    dir: translatedOnly ? langDir(lang) : "ltr",
    bt: (key) => bilingual(lang, key, translatedOnly),
  };
}
